
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz/take/questions/[step]",
      function () {
        return require("private-next-pages/quiz/take/questions/[step]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz/take/questions/[step]"])
      });
    }
  